import type { Component } from 'vue'

type IconModule = {
    default: Component
}

const iconModules = import.meta.glob<IconModule>('./*.vue', { eager: true })

export const iconComponents = Object.fromEntries(
    Object.entries(iconModules).map(([path, module]) => [
        path.split('/').pop()?.replace(/\.vue$/, '') ?? path,
        module.default
    ])
) as Record<string, Component>

export const availableIconNames = Object.keys(iconComponents).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' })
)
